module.exports = __webpack_public_path__ + "img/send.cc085ea7.svg";